
import React, { lazy, Suspense } from 'react';

import HomeStaffShiftDetail from './components/pages/private/HomeStaffShiftDetail';
import SupportShift from './components/pages/private/SupportShift';
import SupportShiftDetail from './components/pages/private/SupportShiftDetail';

import PersonalSignInOutTime from './components/pages/private/PersonalSignInOutTime';
import StaffList from './components/pages/private/StaffList';
import EditStaffShift from './components/pages/private/EditStaffShift';

import AdjustStaffShift from './components/pages/private/AdjustStaffShift';
import AdjustStaffShiftDetail from './components/pages/private/AdjustStaffShiftDetail';

import ExpectWorkTime from './components/pages/private/ExpectWorkTime';
import ExpectWorkTimeByDay from './components/pages/private/ExpectWorkTimeByDay';

import FinalWorkTime from './components/pages/private/FinalWorkTime';
import LeaveTypeList from './components/pages/private/LeaveTypeList';
import FinalWorkTimeByDay from './components/pages/private/FinalWorkTimeByDay';

import TotalSignInOutTime from './components/pages/private/TotalSignInOutTime';
import StaffSalaryList from './components/pages/private/StaffSalaryList';
import DailyCostByHour from './components/pages/private/DailyCostByHour';

import ShowQrCode from './components/pages/private/ShowQRCode';
import FillShift from './components/pages/private/FillShift';
import Store from './components/pages/home/Store';
import StaffJobList from './components/pages/private/StaffJobList';
import LeaveList from './components/pages/private/LeaveList';
import SigningLeaveRec from './components/pages/private/SigningLeaveRec';
import SigningOvertimeRec from './components/pages/private/SigningOvertimeRec';
import SalaryReceipt from './components/pages/private/SalaryReceipt';
import SigningManagement from './components/pages/private/SigningManagement';
import SigningManagementToSalary from './components/pages/private/SigningManagementToSalary';
import ShiftSheet from './components/pages/private/ShiftSheet';
import LeaveExpireNotice from './components/pages/private/LeaveExpireNotice';
import MonthHour from './components/pages/private/MonthHour';
import Organization from './components/pages/private/Organization';
import IncomeStatement from './components/pages/private/IncomeStatement';
import moment from 'moment';
import FillLeave from './components/FillLeave';
import RentallList from './components/pages/private/RentalList';

//NewSupportShift

// 1: sa    2: 店長     3: 會計     4: 員工      5: 主廚 外場副店長 吧檯副店長

function LoadingComponent() {
  return (
    <div className="loading__overlay">
      <div className="loading__content">
        <div className="spinner" />
      </div>
    </div>
  );
}

function Home() {
  const OtherComponent = lazy(() => import('./components/pages/home/Index'));
  return (
    <Suspense fallback={<LoadingComponent />}>
      <OtherComponent />
    </Suspense>
  );
}

// function HomeStaffShiftDetail() {
//   const OtherComponent = lazy(() => import('./components/pages/private/HomeStaffShiftDetail'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function SupportShift() {
//   const OtherComponent = lazy(() => import('./components/pages/private/SupportShift'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function SupportShiftDetail() {
//   const OtherComponent = lazy(() => import('./components/pages/private/SupportShiftDetail'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function PersonalSignInOutTime() {
//   const OtherComponent = lazy(() => import('./components/pages/private/PersonalSignInOutTime'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function StaffList() {
//   const OtherComponent = lazy(() => import('./components/pages/private/StaffList'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function EditStaffShift() {
//   const OtherComponent = lazy(() => import('./components/pages/private/EditStaffShift'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function AdjustStaffShift() {
//   const OtherComponent = lazy(() => import('./components/pages/private/AdjustStaffShift'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function AdjustStaffShiftDetail() {
//   const OtherComponent = lazy(() => import('./components/pages/private/AdjustStaffShiftDetail'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function ExpectWorkTime() {
//   const OtherComponent = lazy(() => import('./components/pages/private/ExpectWorkTime'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function ExpectWorkTimeByDay() {
//   const OtherComponent = lazy(() => import('./components/pages/private/ExpectWorkTimeByDay'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function FinalWorkTime() {
//   const OtherComponent = lazy(() => import('./components/pages/private/FinalWorkTime'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function FinalWorkTimeByDay() {
//   const OtherComponent = lazy(() => import('./components/pages/private/FinalWorkTimeByDay'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function TotalSignInOutTime() {
//   const OtherComponent = lazy(() => import('./components/pages/private/TotalSignInOutTime'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function StaffSalaryList() {
//   const OtherComponent = lazy(() => import('./components/pages/private/StaffSalaryList'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function SigningManagement() {
//   const OtherComponent = lazy(() => import('./components/pages/private/SigningManagement'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function SigningManagementToSalary() {
//   const OtherComponent = lazy(() => import('./components/pages/private/SigningManagementToSalary'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

// function ShiftSheet() {
//   const OtherComponent = lazy(() => import('./components/pages/private/ShiftSheet'));
//   return (
//     <Suspense fallback={<LoadingComponent />}>
//       <OtherComponent />
//     </Suspense>
//   );
// }

const router = [
  {
    name: 'home',
    route: '/~',
    Component: Home,
    auth: 'all',
    exact: true,
  }, {
    name: 'home',
    route: '/',
    Component: Home,
    auth: 'all',
    exact: true,
  }, {
    name: 'Store',
    route: '/store',
    Component: Store,
    auth: 'all',
    exact: true,
  }, {
    name: 'ShowQRcode',
    route: '/showqrcode',
    Component: ShowQrCode,
    auth: 'all',
    exact: true,
  }, {
    name: 'SupportShift',
    route: '/supportShift',
    Component: SupportShift,
    auth: 'all',
    exact: true,
  },
   {
    name: 'FillShift',
    route: '/fillShift',
    Component: FillShift,
    auth:  [1, 2, 3, 4, 5, 6],
    exact: true,
  },
   {
    name: 'SupportStaffShiftDetail',
    route: '/supportStaffShiftDetail/:day',
    Component: SupportShiftDetail,
    auth: 'all',
    exact: true,
  }, {
    name: 'HomeStaffShiftDetail',
    route: '/homeStaffShiftDetail/:day',
    Component: HomeStaffShiftDetail,
    auth: 'all',
    exact: true,
  }, {
    name: 'staffList',
    route: '/staffList',
    Component: StaffList,
    auth: [1, 2, 3],
    exact: true,
  },  {
    name: 'rentallList',
    route: '/rentallList',
    Component: RentallList,
    auth: [1, 2, 3],
    exact: true,
  },{
    name: 'staffJobList',
    route: '/staffJobList',
    Component: StaffJobList,
    auth: [1, 2, 3],
    exact: true,
  }, {
    name: 'editstaffshift',
    route: '/editstaffshift',
    Component: EditStaffShift,
    auth: [1, 2, 3, 4, 5, 6],
    exact: true,
  }, {
    name: 'peronalsigininouttime',
    route: '/peronalsigininouttime',
    Component: PersonalSignInOutTime,
    auth: [1, 2, 3, 4, 5, 6],
    exact: true,
  }, 
  // {
  //   name: 'expectedWorkTimeShift',
  //   route: '/expectedWorkTimeShift',
  //   Component: ExpectWorkTime,
  //   auth: [1, 2, 3],
  //   exact: true,
  // }, 
  {
    name: 'expectedWorkTimeByDay',
    route: '/expectedWorkTimeByDay/:day',
    Component: ExpectWorkTimeByDay,
    auth: [1, 2, 3],
    exact: true,
  }, {
    name: 'finalWorkTimeShift',
    route: '/finalWorkTimeShift',
    Component: FinalWorkTime,
    auth: [1, 2, 3],
    exact: true,
  }, {
    name: 'finaldWorkTimeByDay',
    route: '/finalWorkTimeByDay/:day',
    Component: FinalWorkTimeByDay,
    auth: [1, 2, 3],
    exact: true,
  }, {
    name: 'totalsigininouttime',
    route: '/totalsigininouttime',
    Component: TotalSignInOutTime,
    auth: [1, 2, 3, 5],
    exact: true,
  },
  {
    name: 'adjuststaffshift',
    route: '/adjuststaffshift',
    Component: AdjustStaffShift,
    auth: [1, 2, 3, 5],
    exact: true,
  },
  {
    name: 'leavetypelist',
    route: '/leavetypelist',
    Component: LeaveTypeList,
    auth: [1, 2, 3],
    exact: true,
  },
  {
    name: 'leavelist',
    route: '/leavelist',
    Component: LeaveList,
    auth: 'all',
    exact: true,
  },
  {
    name: 'salaryreceipt',
    route: '/salaryreceipt',
    Component: SalaryReceipt,
    auth: 'all',
    exact: true,
  },
  {
    name: 'signingleaverec',
    route: '/signingleaverec',
    Component: SigningLeaveRec,
    auth: [1, 2, 3, 5],
    exact: true,
  },
  {
    name: 'signingovertimerec',
    route: '/signingovertimerec',
    Component: SigningOvertimeRec,
    auth: [1, 2, 3, 5],
    exact: true,
  },
  {
    name: 'LeaveExpireNotice',
    route: '/leaveExpireNotice',
    Component: LeaveExpireNotice,
    auth: [1, 2, 3, 5],
    exact: true,
  },
  {
    name: 'adjustStaffShiftDetail',
    route: '/adjustStaffShiftDetail/:day',
    Component: AdjustStaffShiftDetail,
    auth: [1, 2, 3, 5],
    exact: true,
  },
  {
    name: 'staffSalaryList',
    route: '/staffsalary',
    Component: StaffSalaryList,
    auth: [1, 2, 3],
    exact: true,
  },
  {
    name: 'organization',
    route: '/organization',
    Component: Organization,
    auth: [1, 2, 3],
    exact: true,
  },
  {
    name: 'dailyCostByHour',
    route: '/dailyCostByHour',
    Component: DailyCostByHour,
    auth: [1, 2, 3],
    exact: true,
  },
  {
    name: 'dailyCostByHour',
    route: '/dailyCostByHour/:day',
    Component: DailyCostByHour,
    auth: [1, 2, 3],
    exact: true,
  },
  {
    name: 'SigningManagement',
    route: '/signinmanagement',
    Component: SigningManagement,
    auth: [1, 2, 5],
    exact: true,
  },
  {
    name: 'SigningManagementToSalary',
    route: '/signinsalarymanagement',
    Component: SigningManagementToSalary,
    auth: [1, 2, 3, 5],
    exact: true,
  },
  {
    name: 'MonthHour',
    route: '/monthHour',
    Component: MonthHour,
    auth: [1, 2, 3],
    exact: true,
  },
  {
    name: 'IncomeStatement',
    route: '/incomeStatement',
    Component: IncomeStatement,
    auth: [1, 2],
    exact: true,
  },
  {
    name: 'ShiftSheet',
    route: '/shiftsheet',
    Component: ShiftSheet,
    auth: 'all',
    exact: true,
  },
];

export default router;
